import React from "react";
import { LogIn, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const startGoogleLogin = () => {
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

const LoginButton = () => {
  const { user, logout, loading } = useAuth();

  if (loading) {
    return (
      <div
        className="hidden sm:block w-20 h-7 rounded-md bg-white/5 animate-pulse"
        data-testid="auth-loading"
      />
    );
  }

  if (user) {
    return (
      <div className="flex items-center gap-2" data-testid="user-pill">
        {user.picture ? (
          <img
            src={user.picture}
            alt={user.name}
            className="w-7 h-7 rounded-full border border-white/15"
            referrerPolicy="no-referrer"
          />
        ) : (
          <div className="w-7 h-7 rounded-full bg-white/10 border border-white/15 flex items-center justify-center text-[11px]">
            {user.name?.slice(0, 1).toUpperCase()}
          </div>
        )}
        <div className="hidden md:flex flex-col leading-tight">
          <span className="text-[12px] font-medium">{user.name}</span>
          <span className="text-[10px] text-white/40 truncate max-w-[140px]">{user.email}</span>
        </div>
        <button
          type="button"
          onClick={logout}
          data-testid="logout-btn"
          className="text-[11px] inline-flex items-center gap-1 px-2 py-1 rounded-md border border-white/10 hover:border-white/30 text-white/70 hover:text-white transition"
          aria-label="Sign out"
        >
          <LogOut className="w-3 h-3" />
          <span className="hidden sm:inline">Sign out</span>
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={startGoogleLogin}
      data-testid="login-btn"
      className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-md bg-white text-black hover:bg-white/90 transition"
    >
      <LogIn className="w-3.5 h-3.5" /> Sign in with Google
    </button>
  );
};

export default LoginButton;
